import { FORMAT_REGIONS, SUPPORTED_LOCALES, type LocaleType } from './locales.js';

/**
 * A person's language setting (`preferences.locale`, T-0472, concept §4.1): a language FEATit speaks, or
 * `null`, which means "follow my browser" and is what every person has until they choose. It follows the
 * person to every device and to the email FEATit sends them.
 */
export type LocaleChoiceType = LocaleType | null;

/**
 * The region of the person's dates and numbers (F-0615): a tag from `FORMAT_REGIONS`, or `null`, which means
 * "follow this device" and is the default. It applies only while its language is the one shown.
 */
export type FormatRegionChoiceType = string | null;

export interface ILocalePreferences {
  locale: LocaleChoiceType;
  region: FormatRegionChoiceType;
}

export const DEFAULT_LOCALE_PREFERENCES: ILocalePreferences = { locale: null, region: null };

/** A region a person may pick, or `null`; any other tag is no region. */
export function isFormatRegionChoice(value: unknown): value is FormatRegionChoiceType {
  return (
    value === null ||
    SUPPORTED_LOCALES.some((locale) => FORMAT_REGIONS[locale].includes(value as string))
  );
}

export function isLocaleChoice(value: unknown): value is LocaleChoiceType {
  return value === null || (SUPPORTED_LOCALES as readonly unknown[]).includes(value);
}
